import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-popover-comment-post',
  templateUrl: './popover-comment-post.component.html',
  styleUrls: ['./popover-comment-post.component.scss']
})
export class PopoverCommentPostComponent implements OnInit {
  @Input() autor: boolean;
  @Input() callback: any;

  constructor() {}

  ngOnInit() {}
}
